import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { NavigationExtras, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { Product } from 'src/app/models/interface/product/product';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { Order, OrdersService } from 'src/app/services/api/orders/orders.service';

@Component({
  selector: 'app-product-map-orders',
  templateUrl: './product-map-orders.component.html',
  styleUrls: ['./product-map-orders.component.scss']
})
export class ProductMapOrdersComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input() item: Product;
  @Input() isps: any[];

  displayedColumns: string[] = ['specification', 'action', 'state', 'createdAt', 'externalId', 'link'];
  dataSource: MatTableDataSource<Order>;

  private _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    this.ngOnInit();
  }

  appData: any;

  constructor(private ordersService: OrdersService,
    private notificationsService: NotificationsService,
    private router: Router,
    private appService: AppService) {

  }

  ngOnInit() {
    this.appData = this.appService.settings;
    this.sort.active = 'createdAt';
    this.sort.direction = 'desc';
    if (this.params && !this.dataSource) {
      this.dataSource = new MatTableDataSource();
      this.submitForm();
    }
  }

  submitForm() {
    const sort = this.sort.active + "," + this.sort.direction.toString();
    this.ordersService.getAssociatedProductOrders(this.item.name, sort).subscribe(
      (data) => {
        const orders: Order[] = [];
        for (const productOrder of data) {
          orders.push({
            namingId: productOrder.namingId,
            createdAt: productOrder.createdAt,
            lastModifiedAt: productOrder.lastModifiedAt,
            state: productOrder.state,
            specification: productOrder.specification,
            action: productOrder.action,
            crm: productOrder.crm,
            isp: productOrder.isp,
            externalId: productOrder.externalId
          });
        }
        this.dataSource.data = orders;
      },
      (error) => {
        this.notificationsService.showNotification(
          'No se han podido obtener las órdenes asociadas a este producto',
          NotificationLevel.ERROR);
      }
    );
  }

  navigateToDetail(row: Order) {
    window.open(`${this.appData.baseUrl}${this.appData.basePath}/provision/orders/detail?id=${row.externalId}`, '_blank');
  }

}
